import React, { useState } from 'react';
import { Container, Row, Col, TabContent, TabPane } from 'reactstrap';
import ResetTab from './ResetTab';
const ResetPwd = () => {
  return (
    <Container fluid={true} className="p-0 login-page">
    <Row>
      <Col xs="12">
        <div className="login-card">
          <div className="login-main login-tab">
            {/* <NavAuth callbackNav={callbackNav} selected={selected} /> */}
            <ResetTab />
          </div>
        </div>
      </Col>
    </Row>
  </Container>
  )
}

export default ResetPwd